import { useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { loadConnectAndInitialize } from '@stripe/connect-js';

import config from 'config';
import useCompanyContext from 'common/hooks/useCompanyContext';

import { StripeConnectSessionDocument } from './graphql/stripeConnectSession.gql';

export const useStripeConnect = () => {
  const { companyProfileId } = useCompanyContext();
  const [queryMerchantAccount, { error, loading }] = useLazyQuery(
    StripeConnectSessionDocument,
  );

  // @see https://docs.stripe.com/connect/get-started-connect-embedded-components#load-and-initialize-connect.js
  const [stripeConnectInstance] = useState(() => {
    const fetchClientSecret = async () => {
      const { data } = await queryMerchantAccount({
        fetchPolicy: 'network-only',
        variables: { companyProfileId: companyProfileId ?? '' },
      });

      if (!data?.viewer.company.merchantAccount) {
        throw new Error('Could not retrieve MerchantAccount');
      }

      return data.viewer.company.merchantAccount.providerSession.clientSecret;
    };

    return loadConnectAndInitialize({
      fetchClientSecret,
      publishableKey: config.stripePublishableKey,
    });
  });

  return { error, loading, stripeConnectInstance };
};
